import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import FormAuth from '../../components/FormAuth';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import useErrors from '../../hooks/useErrors';
import { useResetPassword } from '../../hooks/mutations/useUserMutations';
import * as styles from './styles';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const { mutate: resetPassword, isPending } = useResetPassword();
  const { setError, removeError, getErrorMessageByFieldName, errors } = useErrors();

  function handlePassword(e) {
    setPassword(e.target.value);
    removeError('password');
  }

  function handleConfirmPassword(e) {
    setConfirmPassword(e.target.value);
    removeError('confirmPassword');
  }

  function onSubmit() {
    if (!token) {
      toast.error('Link inválido. Solicite um novo link de redefinição.');
      return;
    }

    if (!password) {
      setError({ field: 'password', message: 'A senha é obrigatória' });
      return;
    }

    if (password.length < 6) {
      setError({ field: 'password', message: 'A senha deve ter pelo menos 6 caracteres' });
      return;
    }

    if (password !== confirmPassword) {
      setError({ field: 'confirmPassword', message: 'As senhas não coincidem' });
      return;
    }

    resetPassword(
      { token, password },
      {
        onSuccess: () => {
          toast.success('Senha redefinida com sucesso!');
          navigate('/modellogin');
        },
        onError: (error) => {
          const msg = error?.response?.data?.error || 'Erro ao redefinir senha. O link pode ter expirado.';
          toast.error(msg);
        },
      }
    );
  }

  const isFormValid = Boolean(password && confirmPassword) && errors.length === 0;

  if (!token) {
    return (
      <FormContainer>
        <Center className="center">
          <styles.ErrorContainer>
            <styles.ErrorIcon>⚠️</styles.ErrorIcon>
            <Title
              title="Link inválido"
              subtitle="Este link de redefinição é inválido ou foi usado. Solicite um novo."
            />
            <styles.BackLink>
              <Link to="/forgot-password">Solicitar novo link</Link>
            </styles.BackLink>
          </styles.ErrorContainer>
        </Center>
      </FormContainer>
    );
  }

  return (
    <FormContainer>
      <Center className="center">
        <Title
          title="Criar nova senha"
          subtitle="Escolha uma senha forte para proteger sua conta."
        />

        <FormAuth
          onSubmit={onSubmit}
          buttonTitle="Salvar nova senha"
          isLoading={isPending}
          formValid={isFormValid}
        >
          <GroupInput
            password
            error={getErrorMessageByFieldName('password')}
          >
            <label>Nova senha*</label>
            <input
              type="password"
              placeholder="Mínimo 6 caracteres"
              value={password}
              onChange={handlePassword}
            />
          </GroupInput>

          <GroupInput error={getErrorMessageByFieldName('confirmPassword')}>
            <label>Confirmar senha*</label>
            <input
              type="password"
              placeholder="Repita a nova senha"
              value={confirmPassword}
              onChange={handleConfirmPassword}
            />
          </GroupInput>
        </FormAuth>

        <styles.BackLink>
          <Link to="/modellogin">Voltar para o login</Link>
        </styles.BackLink>
      </Center>
    </FormContainer>
  );
}
